(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["buyer-assurance"] && !Shopify.designMode) return;
  try {
    const updateSchoolEnquiry = (event) => {
    const link = event.target instanceof Element ? event.target.closest('[data-school-enquiry]') : null;
    if (!(link instanceof HTMLAnchorElement)) return;
    const section = link.closest('.shopify-section');
    const form = section?.querySelector('product-form-component form');
    if (!(form instanceof HTMLFormElement)) return;
    const fields = new FormData(form);
    const url = new URL(link.href);
    const message = url.searchParams.get('message') || '';
    url.searchParams.set('message', message
      .replace(/^Variant ID: .*$/m, `Variant ID: ${fields.get('id') || ''}`)
      .replace(/^Quantity: .*$/m, `Quantity: ${fields.get('quantity') || '1'}`));
    link.href = url.href;
  };
  for (const eventName of ['click', 'pointerdown', 'focusin', 'contextmenu']) {
    document.addEventListener(eventName, updateSchoolEnquiry);
  }
  } catch(e) { console.error(e); }
})();

})();
